import { z } from 'zod';

export const email = z
  .string()
  .min(1, { message: 'Please enter your email' })
  .email({ message: 'Email is invalid' })
  .max(100, { message: 'Email is too long' })
  .transform((value) => value.toLowerCase());
